var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBrandwatchLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 84,
    viewBox: "0 0 76 84",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 25.5044V47.5688L25.7762 59.7853L52.1749 31.9866L34.9286 0.510498C34.3682 0.697485 33.8079 0.946808 33.3098 1.25845L4.66959 17.7756C1.74332 19.2715 0 22.201 0 25.5044Z",
    fill: "#57B7DD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.7764 59.7228L56.8447 74.3701L70.9158 66.205L52.1129 31.8618L25.7764 59.7228Z",
    fill: "#F99132"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M67.6161 15.6564L42.338 1.19607C40.0966 -0.0505049 37.4194 -0.362147 34.9912 0.448128L52.2376 31.9242L67.6784 15.6564H67.6161Z",
    fill: "#A98BBC"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M70.9777 66.2675H71.04C73.8417 64.6469 75.5228 61.6552 75.5228 58.4764V25.5044C75.5228 22.2633 73.8417 19.3338 71.04 17.6509L67.6156 15.7188L52.1748 31.9866L70.9777 66.2675Z",
    fill: "#FF6D56"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M0 47.5063V58.4139C0 61.5927 1.74332 64.5845 4.54507 66.205L14.2578 71.8146L25.7762 59.6605L0 47.5063Z",
    fill: "#8AC539"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M14.3203 71.877L33.2477 82.7845C36.0495 84.4051 39.5361 84.4051 42.3379 82.7845L56.8447 74.4324L25.7764 59.7852C25.7764 59.7228 14.3203 71.877 14.3203 71.877Z",
    fill: "#FFBE0A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrandwatchLogo);
export default __webpack_public_path__ + "static/media/brandwatch-logo.4330944a18a6da547c45b384a8c424e9.svg";
export { ForwardRef as ReactComponent };